"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/EnrolStatus.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Switch_template = require("../../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    marko_attrs0 = {
        "class": "btn btn-light btn-lg btn-block"
      },
    marko_attrs1 = {
        "class": "btn btn-secondary btn-lg btn-block"
      },
    marko_attrs2 = {
        "class": "alert border-warning"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Switch_tag({
      by: input.status,
      case: [
          {
              is: "checking",
              renderBody: function(out) {
                out.be("button", marko_attrs0, "2", component);

                Preloader_tag({
                    active: true,
                    class: "font-medium-5"
                  }, out, __component, "3");

                out.ee();
              }
            },
          {
              is: "yes",
              renderBody: function(out) {
                route_link_tag({
                    type: "button",
                    class: "btn btn-success btn-lg btn-block",
                    href: (("/classroom/" + input.type) + "/") + input.id,
                    renderBody: function(out) {
                      Locale_tag({
                          text: "Continue",
                          class: "text-uppercase"
                        }, out, __component, "6");
                    }
                  }, out, __component, "5");
              }
            },
          {
              is: "no",
              renderBody: function(out) {
                out.be("button", marko_attrs1, "8", component, null, 0, {
                    onclick: __component.d("click", () => component.emit('enrol'), false)
                  });

                Locale_tag({
                    text: "Enrol",
                    class: "text-uppercase"
                  }, out, __component, "9");

                out.ee();
              }
            }
        ],
      default: {
          renderBody: function(out) {
            out.be("div", marko_attrs2, "11", component);

            Locale_tag({
                text: input.status
              }, out, __component, "12");

            out.ee();
          }
        }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
